import React from 'react'
import { homeIcon } from '../../constant/icon'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
    const navigate = useNavigate()
    return (
        <div className=''>
            <div className='container mx-auto h-screen flex items-center justify-center md:p-4 p-5'>
                <div className='text-center'>
                    <div className="mx-auto mb-6 flex h-48 w-full max-w-md items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 text-slate-400 sm:h-56" aria-hidden>
                        <svg viewBox="0 0 120 80" className="h-32 w-40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="8" y="12" width="104" height="56" rx="6" stroke="currentColor" strokeWidth="2" />
                            <path d="M28 52h64M40 36h40M40 44h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <text x="60" y="28" textAnchor="middle" fill="currentColor" fontSize="14" fontWeight="600">404</text>
                        </svg>
                    </div>
                    <p className='text-3xl mb-2'>Page Not Found⚠️</p>
                    <p className='text-xl mb-5'>We couldn′t find the page you are looking for.</p>
                    <button className='bg-customBlue text-white rounded-xl text-lg font-medium px-8 py-3' onClick={() => navigate('/')}>
                        <i className={`${homeIcon} me-3`}></i>
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    )
}

export default NotFound